import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './MiniApp.jsx'
import { LangProvider } from './i18n.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <LangProvider>
      <App />
    </LangProvider>
  </React.StrictMode>
)
